import { lazy } from 'react';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import { RootLayout } from '@/components/layout/RootLayout';
import { RouteError } from '@/components/RouteError';
import { RequireAuth } from '@/components/RequireAuth';
// 인증 화면은 자주 진입하고 작으므로 메인 번들에 포함(재배포 후 stale lazy-chunk 404 방지).
import LoginPage from '@/pages/auth/LoginPage';
import RegisterPage from '@/pages/auth/RegisterPage';

// 나머지는 코드 분할 유지.
const HomePage = lazy(() => import('@/pages/home/HomePage'));
const BundleDetailPage = lazy(
  () => import('@/pages/bundle/BundleDetailPage'),
);
const MyOrdersPage = lazy(() => import('@/pages/mypage/MyOrdersPage'));
const MyPage = lazy(() => import('@/pages/mypage/MyPage'));
const ShowcasePage = lazy(() => import('@/pages/showcase/ShowcasePage'));

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <HomePage /> },
      // /bundles reuses the same filtered listing as the home feed.
      { path: 'bundles', element: <HomePage /> },
      { path: 'bundles/:id', element: <BundleDetailPage /> },
      { path: 'showcase', element: <ShowcasePage /> },
      { path: 'auth/login', element: <LoginPage /> },
      { path: 'auth/register', element: <RegisterPage /> },
      {
        path: 'me',
        element: (
          <RequireAuth>
            <MyPage />
          </RequireAuth>
        ),
      },
      {
        path: 'me/orders',
        element: (
          <RequireAuth>
            <MyOrdersPage />
          </RequireAuth>
        ),
      },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
